/* eslint-disable @typescript-eslint/naming-convention */
import { Injectable } from '@angular/core';
import {
  ActionPerformed,
  PushNotifications,
  Token,
} from '@capacitor/push-notifications';
import { Platform } from '@ionic/angular';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {
  private actionPerformedSubject$ = new ReplaySubject<ActionPerformed>(1);

  constructor(private platform: Platform) {
    if (this.platform.is('capacitor')) {
      PushNotifications.addListener(
        'pushNotificationActionPerformed',
        (actionPerformed: ActionPerformed) => {
          this.actionPerformedSubject$.next(actionPerformed);
        },
      );
    }
  }

  get actionPerformed$(): Observable<ActionPerformed> {
    return this.actionPerformedSubject$.asObservable();
  }

  getToken(): Promise<string> {
    return new Promise((resolve, reject) => {
      try {
        PushNotifications.requestPermissions().then((result) => {
          if (result.receive === 'granted') {
            PushNotifications.register();
            PushNotifications.addListener('registration', (token: Token) => {
              console.log(
                'PushNotifications registration token: ',
                token.value,
              );
              resolve(token.value);
            });
            PushNotifications.addListener('registrationError', (error: any) => {
              console.log(
                'PushNotifications registration error: ' +
                  JSON.stringify(error),
              );
              reject();
            });
          } else {
            reject();
          }
        });
      } catch {
        reject();
      } finally {
        PushNotifications.removeAllListeners();
        PushNotifications.addListener(
          'pushNotificationActionPerformed',
          (actionPerformed: ActionPerformed) => {
            this.actionPerformedSubject$.next(actionPerformed);
          },
        );
      }
    });
  }

  unregister(): void {
    if (this.platform.is('capacitor')) {
      PushNotifications.unregister();
    }
  }
}
